import React, { useState } from "react";
import axios from "axios";
import { serviceConfig } from "configs";
import RadioButton from "common/RadioButton/RadioButton";
import { Input } from "common/Input/Input";

import { Htag } from "common/Htag/Htag";
import { P } from "common/P/P";
import FileItem from "common/FileItem/FolderItem";
import { Spinner } from "modules/loaders";
import PdfViewer from "common/PdfViewer/PdfViewer";

const ContextSearchPage = () => {
	const [documentType, setDocumentType] = useState("dgh");
	const [searchText, setSearchText] = useState("");
	const [filteredResults, setFilteredResults] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedPdfFile, setSelectedPdfFile] = useState<string | null>(null);
	const [pdfModalOpen, setPdfModalOpen] = useState(false);

	const handleDocumentTypeChange = (e: any) => {
		setDocumentType(e.target.value);
		// Reset filtered results on type change
		setFilteredResults([]);
	};

	const handleSearchTextChange = (e: any) => {
		setSearchText(e.target.value);
	};

	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			const response = await axios.post(
				`${serviceConfig.apiUrl}/context-search`,
				{
					type: documentType,
					searchText: searchText,
				}
			);
			setFilteredResults(response.data.files); // Assuming the backend returns an object with a 'files' array
		} catch (error) {
			console.error("Error fetching filtered data:", error);
		} finally {
			setIsLoading(false); // Stop loading regardless of the outcome
		}
	};

	const handleDownloadFile = (fileName: string) => {
		window.open(`${serviceConfig.apiUrl}/download?path=${fileName}`, "_blank");
	};
	const handlePdfClick = (pdfUrl: string) => {
		const fullUrl = `${serviceConfig.apiUrl}/${pdfUrl}`;
		setSelectedPdfFile(fullUrl);
		setPdfModalOpen(true);
	};

	return (
		<div className="grid grid-flow-row auto-rows-max gap-6 px-6 py-6 min-h-[90vh]">
			<div className="grid grid-cols-1 gap-6">
				<div className="grid grid-cols-1 gap-2">
					<Htag tag="h2" type="medium" className="text-mainColor">
						Resminamanyň görnüşi
					</Htag>
					<div className="grid gap-6 grid-cols-maxFour">
						<RadioButton
							name="documentType"
							value="dgh"
							label="Daşarky gelen resminamalar"
							checked={documentType === "dgh"}
							onChange={handleDocumentTypeChange}
							id="dgh"
						/>
						<RadioButton
							name="documentType"
							value="dih"
							label="Daşarky iberilen resminamalar"
							checked={documentType === "dih"}
							onChange={handleDocumentTypeChange}
							id="dih"
						/>
						<RadioButton
							name="documentType"
							value="igh"
							label="Içerki gelen resminamalar"
							checked={documentType === "igh"}
							onChange={handleDocumentTypeChange}
							id="igh"
						/>
						<RadioButton
							name="documentType"
							value="iih"
							label="Içerki iberilen resminamalar"
							checked={documentType === "iih"}
							onChange={handleDocumentTypeChange}
							id="iih"
						/>
					</div>
				</div>
				<Input
					name="searchText"
					placeholder="Gözleg..."
					value={searchText}
					onChange={handleSearchTextChange}
					appearance="default"
					minWidth={true}
					minWidthValue="min-w-[34rem]"
					width="w-max"
					type="text"
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleSubmit();
						}
					}}
				/>
			</div>
			{isLoading ? (
				<Spinner />
			) : (
				filteredResults.length > 0 && (
					<div className="grid grid-cols-6 gap-6 lg:grid-cols-9">
						{filteredResults.map((file: any, idx: number) => {
							const normalizedPath = file.path.replace(/\\/g, "/");
							return (
								<FileItem
									key={idx}
									name={
										file.name.length > 15
											? `${file.name.substring(0, 15)}...`
											: file.name
									}
									size={file.size}
									type={file.type}
									onDownload={() => handleDownloadFile(file.path)}
									canView={file.type === "pdf"}
									notDeletable={file.type !== "pdf"}
									onView={
										file.type === "pdf"
											? () => handlePdfClick(normalizedPath)
											: undefined
									}
								/>
							);
						})}
					</div>
				)
			)}
			<PdfViewer
				fileUrl={selectedPdfFile}
				isOpen={pdfModalOpen}
				onClose={() => setPdfModalOpen(false)}
			/>
		</div>
	);
};

export default ContextSearchPage;
